import React from 'react';
import Header, { HeaderLeft } from '../../../layout/Header/Header';
import CommonHeaderRight from './CommonHeaderRight';

const ContactQueriesHeader = () => {
	return (
		<Header>
			<HeaderLeft className='h4 mb-0 fw-bold'>Contact Queries</HeaderLeft>
			<CommonHeaderRight />
		</Header>
	);
};

export default ContactQueriesHeader;
